import {
  LOGINDATA,
  pendingCasesData,
  profileDetails,
  SalesData,
  SelfInspecData,
  UserIdManagement,
  BRANCHDATA,
  SingleRow,
  NEWEMPLOYEE,
  RenewalNotification,
  RENEWALS,
  Other_Payouts,
  TOGGLE_FORM,
  Employee_Logout,
  EMPLOYEE_LOGIN_REPORTS,
  TOGGLE_PANNEL,
  UPDATE_LOGIN_REPORTS,
  EMPLOYEE_PENDING_REPORT,
  EMPLOYEE_ISSUE_REPORT,
  EMPLOYEE_REJECTED_REPORT,
  EMPLOYEE_RECONCILIATION_REPORT,
  COMPANY_REVENUE,
  COMPANY_PRODUCT_TYPE,
  POSP_REVENUE,
  EMPLOYEE_REVENUE,
  BRANCHES_LIST,
  POLICY_REPORTS,
  EMPLOYEE_LOOKUP_REPORTS
} from "./actionType";
let initialState = {
  loginData: undefined,
  salesData: [],
  selfInspecData: [],
  profileData: {},
  pendingCases: [],
  userIdManagement: [],
  branches: [],
  singleRow: {},
  NewEmployee: {
    PersonalDetails: {},
    EmpoyeeDetails: {},
    PermissionsForm: {},
  },
  RenewalNotificationData: [],
  Renewals: [],
  Other_Payouts: [],
  sales_pannels: 0,
  offline_active_form: "car",
  employee_login_reports: null,
  employee_pending_reports: null,
  employee_issue_reports: null,
  employee_reject_reports: null,
  employee_recon_reports: null,
  emp_Lookup_Reports:null,
  company_revenue: null,
  company_product_type: null,
  posp_revenue: null,
  employee_revenue: null,
  branches_list: [],
  policy_reports:[]
};

function adminReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SalesData:
      return { ...state, salesData: payload };
    case SelfInspecData:
      return { ...state, selfInspecData: { ...state.selfInspecData, payload } };
    case pendingCasesData:
      return { ...state, pendingCases: payload };
    case profileDetails:
      return { ...state, profileData: payload };
    case UserIdManagement:
      return { ...state, userIdManagement: payload };
    case LOGINDATA:
      return { ...state, loginData: payload };
    case BRANCHDATA:
      return { ...state, branches: payload };
    case SingleRow:
      return { ...state, singleRow: payload };
    case NEWEMPLOYEE:
      return {
        ...state,
        NewEmployee: {
          ...state.NewEmployee,
          [action.payload.form]: {
            ...state.NewEmployee[action.payload.form],
            ...action.payload.data,
          },
        },
      };

    case RenewalNotification:
      return { ...state, RenewalNotificationData: payload };

    case RENEWALS:
      return { ...state, Renewals: payload };

    case Other_Payouts:
      return { ...state, Other_Payouts: payload };

    case TOGGLE_FORM:
      return {
        ...state,
        offline_active_form: payload,
      };
    case TOGGLE_PANNEL:
      return {
        ...state,
        sales_pannels: payload,
      };
    case Employee_Logout:
      return {
        ...state,
        loginData: payload,
      };

    case EMPLOYEE_LOGIN_REPORTS:
      return { ...state, employee_login_reports: payload };
    case EMPLOYEE_PENDING_REPORT:
      return { ...state, employee_pending_reports: payload };
    case EMPLOYEE_ISSUE_REPORT:
      return { ...state, employee_issue_reports: payload };
    case EMPLOYEE_REJECTED_REPORT:
      console.log(payload, "xxxxxxxx");
      return { ...state, employee_reject_reports: payload };
    case EMPLOYEE_RECONCILIATION_REPORT:
      return { ...state, employee_recon_reports: payload };
    case EMPLOYEE_LOOKUP_REPORTS:
      return { ...state, emp_Lookup_Reports: payload };
    case UPDATE_LOGIN_REPORTS:
      return {
        ...state,
        employee_login_reports: [
          ...state.employee_login_reports.filter(
            (report) => report.order_id !== payload.order_id
          ),
          payload,
        ],
      };

    case COMPANY_REVENUE:
      return { ...state, company_revenue: payload };
    case COMPANY_PRODUCT_TYPE:
      return { ...state, company_product_type: payload };
    case POSP_REVENUE:
      return { ...state, posp_revenue: payload };
    case EMPLOYEE_REVENUE:
      return { ...state, employee_revenue: payload };
    case BRANCHES_LIST:
      return { ...state, branches_list: payload };
      case POLICY_REPORTS : 
      return {...state,policy_reports:payload};
    default:
      return state;
  }
}

export { adminReducer };
